export class Referent {
    static jsonMap = {
        id: { key: 'id', optional: true },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    public id: number;
    public code: string;
    public libelle: string;
}
